(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lsx-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const expandStatus = root => root.querySelectorAll('[data-review-status]').forEach(status => {
    const details = status.closest('details');
    if (details) details.open = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => expandStatus(document), { once: true });
  else expandStatus(document);
  document.addEventListener('shopify:section:load', event => expandStatus(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
